import { useState, useEffect } from 'react'
import VerifyPhone from '../VerifyPhone'
import VerifyEmail from '../VerifyEmail'

export default function BookingStep1(props) {

  const [otpVerified, setOtpVerified] = useState(false);
  const [email,setEmail] = useState();
  const [phone,setPhone] = useState({
    country: '',
    number: ''
  });

  useEffect(() => {
    if(otpVerified === true) {
      props.setBkinfo({...props.bkinfo,country:phone.country, phone:phone.number, email:email, last_step: 1})
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[otpVerified]);

  return (
      <>
        <div className="flex flex-col md:flex-row md:gap-5">
          <div className="md:w-1/2">
            <VerifyPhone phone={phone} setPhone={setPhone} setOtpVerified={setOtpVerified}/>          
          </div>
          <span className="border-l border-gold/50 text-center md:text-left block my-5 font-bold text-gold"></span>
          <div className="md:w-1/2">
            <VerifyEmail setEmail={setEmail} setOtpVerified={setOtpVerified}/>    
          </div>
        </div>        
      </>

  );
}